import { Injectable, Inject} from '@angular/core';

export  class PolicyTripDO {
    // private firstName:string;
    // private lasteName:string;
    // private age:string;

    private  id:Number = null;

    private  versionId:any = null;

    private  guid:String = null;

    private  createdDt:Date = null;

    private  updatedDt:Date = null;

    private  createdUser:String = null;

    private  updatedUser:String = null;

    private  tripTypeCd:String = null;

    private  tripRegionCd:String = null;

    private  travelFromCountryCd:String = null;

    private  travelToCountryCd:String = null;

    private  travelFromCityCd:String = null;

    private  travelToCityCd:String = null;

    private travelDepartureDt:Date=null;

    private travelReturnDt:Date=null;

    public getId(): Number{
        return this.id;
    }

    public setId(id:Number) {
        this.id=id;
    }

    public getTravelDepartureDt(): Date{
        return this.travelDepartureDt;
    }

    public setTravelDepartureDt(travelDepartureDt:Date) {
        this.travelDepartureDt=travelDepartureDt;
    }

    public getTravelReturnDt(): Date{
        return this.travelReturnDt;
    }

    public setTravelReturnDt(travelReturnDt:Date) {
        this.travelReturnDt=travelReturnDt;
    }

    
    public getGuid():String{
        return this.guid;
    }

    public setGuid(guid:String){
        this.guid=guid;
    }


    public getCreatedDt(): Date{
        return this.createdDt;
    }

    public setCreatedDt(createdDt:Date){
        this.createdDt=createdDt;
    }

    public getUpdatedDt(): Date{
        return this.updatedDt;
    }

    public setUpdatedDt(updatedDt:Date){
        this.updatedDt=updatedDt;
    }

    public getCreatedUser():any{
        return this.createdUser;
    }

    public setCreatedUser(createdUser:any){
        this.createdUser=createdUser;
    }
    
    public getUpdatedUser():any{
        return this.updatedUser;
    }

    public setUpdatedUser(updatedUser:any){
        this.updatedUser=updatedUser;
    }
    public getVersionId():any{
        return this.versionId;
    }

    public setVersionId(versionId:any){
        this.versionId=versionId;
    }

    public getTripTypeCd():String {
		return this.tripTypeCd;
	}

	public setTripTypeCd(tripTypeCd:String) {
		this.tripTypeCd = tripTypeCd;
	}

	public getTripRegionCd():String {
		return this.tripRegionCd;
	}

	public setTripRegionCd(tripRegionCd:String) {
		this.tripRegionCd = tripRegionCd;
	}

	public getTravelFromCountryCd(): String {
		return this.travelFromCountryCd;
	}

	public setTravelFromCountryCd(travelFromCountryCd:String) {
		this.travelFromCountryCd = travelFromCountryCd;
	}

	public getTravelToCountryCd():String {
		return this.travelToCountryCd;
	}

	public setTravelToCountryCd(travelToCountryCd:String) {
		this.travelToCountryCd = travelToCountryCd;
	}

	public getTravelFromCityCd():String {
		return this.travelFromCityCd;
	}

	public setTravelFromCityCd(travelFromCityCd:String) {
		this.travelFromCityCd = travelFromCityCd;
	}

	public getTravelToCityCd():String {
		return this.travelToCityCd;
	}

	public setTravelToCityCd(travelToCityCd:String) {
		this.travelToCityCd = travelToCityCd;
	}


}
